export default __webpack_public_path__ + "static/media/cs.349e2855.md";